import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { OfferingCardLane } from '@ole-ui/ole-ui-components';
import useMobxStores from 'hooks/useMobxStores';
import { Link } from 'react-mobx-router5';
import { SkillsPathCard } from 'components/OfferingCards';
import { CommonLaneProps } from './types';

const SkillsPathsLane = ({ expanded, onTitleClick }: CommonLaneProps) => {
  const { t } = useTranslation();
  const { learningPathStore } = useMobxStores();

  return (
    <OfferingCardLane
      className="new_lane"
      emptyMessage={
        <p className="empty-message">
          {t('You have no active Skills paths.')}{' '}
          <Link href routeName="skills-paths">
            {t('Browse curated paths or create your own')}
          </Link>
        </p>
      }
      expanded={expanded}
      items={learningPathStore.joinedLearningPaths}
      onTitleClick={onTitleClick}
      renderItem={(entry) => <SkillsPathCard learningPath={entry} />}
      title={t('Enrolled skills paths')}
    />
  );
};

export default observer(SkillsPathsLane);
